import { useToast } from "@commonlibs";
import { PropsWithChildren } from "react";
import useTranslate from "ui/locale/hooks/useTranslate";
import UIErrorEvent from "ui/error/UIErrorEvent";
import useSubscribeToError from "ui/error/hooks/useSubscribeToError";
import { ErrorResourceType } from "ui/locale/i18n.types";

const ErrorHandler = ({ children }: PropsWithChildren): JSX.Element => {
    const translateError = useTranslate("error");
    const { showToast } = useToast();

    const handleUiError = (event: UIErrorEvent) => {
        const message = event.error.details ?? translateError([event.error.message as ErrorResourceType, "somethingWentWrong"]);
        showToast(message, { type: event.error.severity });
    };

    useSubscribeToError({ handleUiError });
    // skipcq: JS-0424
    return <>{children}</>;
};

export default ErrorHandler;
